import React, { useState, useEffect } from 'react';
import { FaUsers, FaUserLock } from 'react-icons/fa';

const BlockUserWidgets = ({ totalUsers, blockedUsers }) => {
  const blockedPercentage = totalUsers
    ? (blockedUsers / totalUsers) * 100
    : 0;

  const [animatedPercentage, setAnimatedPercentage] = useState(0);

  useEffect(() => {
    let step = 0;
    const interval = 10;
    const duration = 1000;
    const steps = duration / interval;
    const stepIncrement = blockedPercentage / steps;

    const timer = setInterval(() => {
      step += 1;
      setAnimatedPercentage(prev =>
        Math.min(prev + stepIncrement, blockedPercentage)
      );
      if (step >= steps) clearInterval(timer);
    }, interval);

    return () => clearInterval(timer);
  }, [blockedPercentage]);

  const calculateStrokeDashoffset = (percentage) => {
    const radius = 45;
    const circumference = 2 * Math.PI * radius;
    return circumference - (percentage / 100) * circumference;
  };

  return (
    <div className="mx-auto pt-3">
      <div className="grid gap-5 sm:grid-cols-1 lg:grid-cols-3">

        {/* Total Users */}
        <div className="bg-white p-4 rounded-2xl shadow-sm flex gap-2 justify-center flex-col items-center">
          <div className="bg-[#f8e6ef] text-[#c51369] p-6 rounded-full">
            <FaUsers size={28} />
          </div>
          <h2 className="text-xl font-medium text-navy-700 tracking-wide">Total Users</h2>
          <p className="text-2xl font-semibold text-[#c51369] tracking-wide">{totalUsers}</p>
        </div>

        {/* Blocked Users */}
        <div className="bg-white p-4 rounded-2xl shadow-sm flex gap-2 justify-center flex-col items-center">
          <div className="bg-[#f8e6ef] text-[#c51369] p-6 rounded-full">
            <FaUserLock size={28} />
          </div>
          <h2 className="text-xl font-medium text-navy-700 tracking-wide">Blocked Users</h2>
          <p className="text-2xl font-semibold text-[#c51369] tracking-wide">{blockedUsers}</p>
        </div>

        {/* Blocked % */}
        <div className="bg-white p-4 rounded-2xl shadow-sm flex flex-col items-center justify-center text-center">
          <h2 className="text-xl font-medium tracking-wide text-navy-700 mb-4">Blocked Users Percentage</h2>
          <div className="w-full flex items-center justify-center">
            <svg width="100" height="100" viewBox="0 0 100 100">
              <circle cx="50" cy="50" r="45" fill="none" className="text-gray-300"
                stroke="currentColor" strokeWidth="10"/>
              <circle cx="50" cy="50" r="45" fill="none" className="text-[#c51369]"
                stroke="currentColor" strokeWidth="10" strokeDasharray="283"
                strokeDashoffset={calculateStrokeDashoffset(animatedPercentage)}
                strokeLinecap="round" transform="rotate(-90 50 50)" />
            </svg>
          </div>
          <div className="mt-4 text-xl font-bold">{animatedPercentage.toFixed(2)}%</div>
        </div>
      </div>
    </div>
  );
};


export default BlockUserWidgets;
